import { ShieldCheck } from "lucide-react";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#00AEEF] via-[#00a0dc] to-[#63C465] flex items-center justify-center p-4">
      <div className="text-center">
        {/* Modern Shield Icon */}
        <div className="relative w-24 h-24 mx-auto mb-8">
          <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse"></div>
          <div className="absolute inset-2 bg-white/30 rounded-full backdrop-blur-sm flex items-center justify-center">
            <div className="w-14 h-14 bg-white rounded-xl shadow-lg flex items-center justify-center">
              <ShieldCheck className="w-8 h-8 text-[#00AEEF]" />
            </div>
          </div>
        </div>
        
        {/* Title */}
        <h1 className="text-4xl font-bold text-white mb-3 tracking-tight">
          Access Restricted
        </h1>
        
        {/* Subtitle */}
        <p className="text-white/80 text-lg mb-8 max-w-md mx-auto">
          This platform requires authorized access. Please use your provided credentials to sign in.
        </p>
        
        {/* Footer */}
        <p className="text-sm text-white/60">
          © 2026 THCO
        </p>
      </div>
    </div>
  );
}
